module.exports = __webpack_public_path__ + "static/media/Speedlines.2f6ae04d.png";